import moment from "moment";
import * as Util from "util/util";
import * as Provider from "./util/provider";
import * as Variant from "./util/variant";

class Sensor {

    getDirection() {
        if (this.level_direction == 0) {
            return "Steady";
        }
        if (this.level_direction == 1) {
            return "Rising";
        }

        return "Falling";
    }

    getDirectionIcon() {
        if (this.level_direction == -1) {
            return "close";
        }
        if (this.level_direction == 2) {
            return "arrow_downward";
        }
        if (this.level_direction == 1) {
            return "arrow_upward";
        }
        return "compare_arrows";
    }

    getDistance(loc) {
        let km = this.getDistanceRaw(loc);
        return (this.sensor_postcode ? (this.sensor_postcode + " - ") : "") + km + "km";
    }

    getDistanceRaw(loc) {
        let loc2 = {lat: this.sensor_lat, lng: this.sensor_long};
        let dist = this.getHaversineDistance(loc, loc2);
        //format to km
        let km = dist / 1000;
        km = parseInt(Math.round(km));
        return km;
    }

    getHaversineDistance(firstLocation, secondLocation) {
        const earthRadius = 6371000; // metres

        const diffLat = (secondLocation.lat - firstLocation.lat) * Math.PI / 180;
        const diffLng = (secondLocation.lng - firstLocation.lng) * Math.PI / 180;

        const arc = Math.cos(
            firstLocation.lat * Math.PI / 180) * Math.cos(secondLocation.lat * Math.PI / 180)
            * Math.sin(diffLng / 2) * Math.sin(diffLng / 2)
            + Math.sin(diffLat / 2) * Math.sin(diffLat / 2);
        const line = 2 * Math.atan2(Math.sqrt(arc), Math.sqrt(1 - arc));

        return earthRadius * line;
    };

    comms() {
        return moment.unix(this.sensor_comms_unix).format("DD MMM YYYY HH:mm");
    }

    nextComms() {
        return moment.unix(this.sensor_comms_unix + this.update * 60).format("DD MMM YYYY HH:mm");
    }

    shouldRed() {
        if (this.hi_res_sensor != null) {
            const hiRes = this.hi_res_sensor;
            Object.setPrototypeOf(hiRes, Sensor.prototype);
            return hiRes.shouldRed();
        }
        return this.isWarning() || this.isAboveAlert() || this.isAboveActCon() || this.notTypical();
    }

    shouldRedMarker() {
        if (this.hi_res_sensor != null) {
            const hiRes = this.hi_res_sensor;
            Object.setPrototypeOf(hiRes, Sensor.prototype);
            return hiRes.shouldRed();
        }
        return this.isWarning() || this.isAboveAlert() || this.isAboveActCon();
    }

    isWarning() {
        return this.warning_level < this.current_level && this.warning_level > 0;
    }

    isAboveAlert() {
        return this.alert_level < this.current_level && this.alert_level > 0;
    }

    isAboveActCon() {
        return this.act_con_level < this.current_level && this.act_con_level > 0;
    }

    isAboveCommunityLevel() {
        return this.smartphone_warning < this.current_level && this.smartphone_warning > 0;
    }

    getBackground() {
        if (this.isOnline()) {
            return this.shouldRed() ? "#ff4546" : "#31945B";
        }
        return "#00A0E4";
    }

    matches(query) {
        let q = query.trim().toLowerCase();
        if (q == "") {
            return true;
        }
        return this.sensor_name.toLowerCase().indexOf(q) !== -1 || this.sensor_postcode.toLowerCase().indexOf(q) !== -1;
    }

    isHiRes() {
        return this.outstation_type == 3;
    }

    getGsmIcon() {
        let signal = this.gsm_signal;
        return Util.getGsmIcon(signal);
    }

    isOnline() {
        return this.online || this.provider != "vl";
    }

    cameraType() {
        if (this.variant == Variant.IP_CAMERA) {
            return "IP Camera";
        } else if (this.twin_camera) {
            return "GSM Camera (Twin Head)";
        } else if (this.ptz_system) {
            return "GSM Camera (Multi Head)";
        }
        return "GSM Camera";
    }

    notTypical() {
        if (this.isVL()) {
            return this.isWarning();
        }
        return this.current_level > this.typicalHigh || this.current_level < this.typicalLow;
    }

    notFlood() {
        if (this.isVL()) {
            return !this.isWarning();
        }
        return this.current_level < this.typicalHigh;
    }

    notBelow() {
        return this.current_level > this.typicalLow;
    }

    onlineAndCamera() {
        return this.variant != Variant.GAUGE && this.isOnline();
    }

    offlineAndCamera() {
        return this.variant != Variant.GAUGE && !this.isOnline();
    }

    isCamera() {
        return this.variant != Variant.GAUGE;
    }

    isVL() {
        return this.provider == Provider.VL;
    }

    isEA() {
        return this.provider == Provider.EA;
    }

    isNRW() {
        return this.provider == Provider.NRW;
    }

    isOnlineForSortingPurposes() {
        return this.isOnline() || this.rapid_deployment;
    }

}

export default Sensor;